export class CreateVehicleModelModel {
  public modelo: string = ''
  public tipoVeiculoId: number = 0
}

export class EditVehicleModelModel {
  public id: number = 0
  public descricao: string = ''
  public tipoVeiculoId: number = 0
}

export class DeleteVehicleModelModel {
  public id: number = 0
  public descricao: string = ''
}

export class SearchVehicleModelModel {
  public modelo: string = ''
}

export class CreateVehicleModelResponse {
  public response: any
}
export class EditVehicleModelResponse {
  public response: any
}
export class DeleteVehicleModelResponse {
  public response: any
}
export class PagedVehicleModelResponse {
  public response: any
}
